<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/intelligent/scheduling/details/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList">
            </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList">
            </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('paichengmingxizhuangtai')">
            <yi_dictionary_select :multiple="true" :max="10" :type="'SCHEDULE_DETAILS_STATUS'"
              :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jiaoqi')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.deliveryPeriodDateStart"
              :end.sync="yt.conditions.deliveryPeriodDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ deliveryPeriodDateStart: begin(), deliveryPeriodDateEnd: end() })">{{
      $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button :loading="exportExcelLoading" size="mini" icon="yicon yicon-export" :title="$t('daochu')"
          @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: "web_scheduling_scheduling_detail_list",
  data() {
    return {
      exportExcelLoading: false,
      columns: [{
        label: "shebeimingcheng",
        prop: "equipment.name", width: 100
      },
      {
        label: "jihuadanhao",
        prop: "plan.no",
        width: 180
      }, {
        label: "ERPgongdanhao",
        prop: "plan.erpNo",
        width: 130
      }, {
        label: "shengchangongdanhao",
        prop: "wo.no",
        width: 180
      }, {
        label: "mujubianhao",
        prop: "mould.no",
        width: 130
      }, {
        label: "mujumingcheng",
        prop: "mould.name", width: 130
      }, {
        label: "chanpinbianma",
        prop: "material.code",
        width: 130
      }, {
        label: "chanpinmingcheng",
        prop: "material.name",
        width: 130
      }, {
        label: "paichanshuliang",
        prop: "wo.planQuantity",
        width: 130
      }, {
        label: "yibaogongliangpinshu",
        prop: "wo.finishGoodQuantity",
        width: 130
      }, {
        label: "yibaogongbuliangpinshu",
        prop: "wo.finishBadQuantity",
        width: 130
      }, {
        label: "jiaoqi",
        prop: "deliveryPeriodDate",
        type: "time",
        width: 180
      }, {
        label: "chaoqifengxian",
        prop: "overdueRisk",
        width: 80,
        type: "bool",
        iln18: ["shi", "fou"]
      }, {
        label: "paichengmingxizhuangtai",
        prop: "status",
        width: 130,
        type: "tag",
        tags: {
          1: { color: "#F56C6C", text: this.$t("UNISSUED") }, 2: {
            color: "#67C23A", text: this.$t("GRANT")
          }, 3: { color: "#dc362e", text: this.$t("PENDING") }
        }
      }, {
        label: "jihuakaishishijian",
        prop: "planStartTime",
        type: "time",
        width: 180
      },
      {
        label: "jihuawanchengshijian",
        prop: "planEndTime",
        type: "time", width: 180
      }, {
        label: "shijikaishishijian",
        prop: "wo.actualStartTime",
        type: "time",
        width: 180
      },
      {
        label: "shijiwanchengshijian",
        prop: "wo.actualEndTime",
        type: "time",
        width: 180
      }],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, "deliveryPeriodDateStart", this.begin());
      this.$set(this.yt.conditions, "deliveryPeriodDateEnd", this.end());
    }, 300);
  },
  methods: {
    beforeGet(params) {
      params["deliveryPeriodDateStart"] = this.begin();
      params["deliveryPeriodDateEnd"] = this.end();
      return params;
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "01" + " 00:00:00").getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
      return end;
    },
    exportExcel() {
      this.exportExcelLoading = true;
      let params = this.yt.conditions;
      params.materialId = this.yt.conditions.materialIdList;
      params.equipmentId = this.yt.conditions.equipmentIdList;
      params.status = this.yt.conditions.statusList;
      delete params.materialIdList;
      delete params.equipmentIdList;
      delete params.statusList;
      delete params.orderBy;
      return this.http
        .get("/web/report/export/aps_scheduling_details_export", { params })
        .then((res) => {
          this.$message.success(this.$t(res.msg));
          this.exportExcelLoading = false;
          this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.exportExcelLoading = false;
        });
    },
  },
};
</script>

<style scoped="scoped"></style>
